export const FETCH_COST_FILE_TEMPLATE = 'FETCH_COST_FILE_TEMPLATE';
export const RECEIVE_COST_FILE_TEMPLATE = 'RECEIVE_COST_FILE_TEMPLATE';
export const SAVE_COST_FILE_TEMPLATE = 'SAVE_COST_FILE_TEMPLATE';
export const RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS = 'RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS';
export const DELETE_COST_FILE_TEMPLATE = 'DELETE_COST_FILE_TEMPLATE';
export const RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS = 'RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS';
export const RESET_COST_FILE_TEMPLATE_DATA = 'RESET_COST_FILE_TEMPLATE_DATA';

export const fetchCostFileTemplate = (suvc) => ({
  type: FETCH_COST_FILE_TEMPLATE,
  data: { suvc },
});

export const receiveCostFileTemplate = (suvc, response) => ({
  type: RECEIVE_COST_FILE_TEMPLATE,
  data: { suvc, response },
});

// templateId is absent for a new template (POST) and present for an existing one (PATCH)
export const saveCostFileTemplate = ({
  suvc, templateId, templateName, columns
}) => ({
  type: SAVE_COST_FILE_TEMPLATE,
  data: {
    suvc, templateId, templateName, columns
  },
});

export const receiveCostFileTemplateSaveStatus = (suvc, response) => ({
  type: RECEIVE_COST_FILE_TEMPLATE_SAVE_STATUS,
  data: { suvc, response },
});

export const deleteCostFileTemplate = (suvc, templateId) => ({
  type: DELETE_COST_FILE_TEMPLATE,
  data: { suvc, templateId },
});

export const receiveCostFileTemplateDeleteStatus = (suvc) => ({
  type: RECEIVE_COST_FILE_TEMPLATE_DELETE_STATUS,
  data: { suvc },
});

export const resetCostFileTemplateData = () => ({
  type: RESET_COST_FILE_TEMPLATE_DATA,
});
